module.exports = __webpack_public_path__ + "assets/df10c8f804c8fc445986edf764d74433.mp3";